import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Nav from "react-bootstrap/Nav";
import { Navbar, Dropdown, Container } from "react-bootstrap";
import { appConfig } from '../../config/app';
import BrandLogo from '../shared/BrandLogo';
import { isPaidSubscriber } from '../../utils/AuthorizationCheck';

const HeaderLoggedInDesktop = ({auth}) => {
    //console.log(auth);

    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
        ) {
            setShowDropdown(false);
        }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);



    // Add null checks to prevent errors when auth data is still loading
    const userInitial = auth?.user?.first_name ? auth.user.first_name.charAt(0).toUpperCase() : null;

    // Don't render if auth data isn't loaded yet
    if (!auth || !auth.user || !auth.user.permission) {
        return (
            <div className="d-lg-block d-none mb-3">
                <Navbar fixed="top" collapseOnSelect expand="lg" variant="dark" className="navbar-glass">
                    <Navbar.Brand>
                        <BrandLogo />
                    </Navbar.Brand>
                </Navbar>
            </div>
        );
    }

    return (
        <>
        <div className="d-lg-block d-none mb-3">            
                <Navbar fixed="top" collapseOnSelect expand="lg" variant="dark" className="navbar-glass">
                    <Container fluid>
                        <Navbar.Brand>
                            <BrandLogo linkTo="/dashboard" />
                        </Navbar.Brand>

                        
                        
                        <Nav className="ms-auto d-flex align-items-center">
                            {/* Left Side - Navigation Links */}
                            {/* <div className="d-flex align-items-center">
                                { auth?.user?.permission?.show_onboarding === false ?
                                    <>
                                        <Link to="/dashboard" 
                                            className="d-inline-flex align-items-center p-2 me-3"
                                            style={{
                                                color: "var(--text-secondary)", 
                                                textDecoration: "none",
                                                fontSize: "1.1rem", 
                                                fontWeight: "400", 
                                                lineHeight: "1.5", 
                                                borderRadius: "0.25rem",
                                            }}
                                        >
                                            <i  className="bi bi-speedometer2" 
                                                style={{
                                                    marginRight: "0.3rem",
                                                    lineHeight: ".8",       
                                                    verticalAlign: "middle",
                                                    color:"var(--text-secondary)" 
                                            }}
                                            ></i> Dashboard
                                        </Link>
                                        
                                        <Link to="/resources" 
                                            className="d-inline-flex align-items-center p-2 me-3"
                                            style={{
                                                color: "var(--text-secondary)", 
                                                textDecoration: "none",
                                                fontSize: "1.1rem", 
                                                fontWeight: "400", 
                                                lineHeight: "1.5", 
                                                borderRadius: "0.25rem",
                                            }}
                                        >
                                            <i  className="bi bi-info-circle" 
                                                style={{
                                                    marginRight: "0.3rem",
                                                    lineHeight: ".8",       
                                                    verticalAlign: "middle",
                                                    color:"var(--text-secondary)"
                                            }}
                                            ></i> Resources
                                        </Link>                                    

                                        <Link to="/invite" 
                                            className="d-inline-flex align-items-center p-2"
                                            style={{
                                                color: "var(--accent-accent)", 
                                                textDecoration: "none",
                                                fontSize: "1.1rem", 
                                                fontWeight: "400", 
                                                lineHeight: "1.5", 
                                                borderRadius: "0.25rem",
                                            }}
                                        >
                                            <i  className="bi bi-gift-fill" 
                                                style={{
                                                    marginRight: "0.3rem",
                                                    lineHeight: ".8",
                                                    verticalAlign: "middle",
                                                    color: "var(--accent-accent)"
                                            }}
                                            ></i> Invite
                                        </Link>
                                    </>
                                    :
                                    ''
                                }
                            </div> */}

                            {/* Center - League Dropdown */}
                            {/* <div className="d-flex align-items-center">
                                <Dropdown>
                                    <Dropdown.Toggle 
                                        variant="outline-light" 
                                        size="sm"
                                        className="league-switcher-toggle"
                                    >
                                        <i className="bi bi-trophy me-2 text-warning"></i>
                                        All Leagues
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="league-switcher-menu">
                                        <Dropdown.Item className="active">All Leagues</Dropdown.Item>
                                        <Dropdown.Item>Friends League 2024</Dropdown.Item>
                                        <Dropdown.Item>Work League 2024</Dropdown.Item>
                                        <Dropdown.Item>Family League 2024</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div> */}

                            {/* Right Side - Discord + Avatar */}
                            <div className="d-flex align-items-center">
                                {/* Discord Logo */}
                                <a 
                                    href={appConfig.social.discord}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="me-3"
                                    style={{ fontSize: '1.5rem', color: '#5865f2' }}
                                >
                                    <i className="fab fa-discord"></i>
                                </a>

                                {/* Avatar Dropdown */}
                                <div className="d-flex align-items-center p-1" ref={dropdownRef}>
                                    <Dropdown show={showDropdown} onToggle={() => {}}>
                                        <div
                                        as="div"
                                        onClick={() => setShowDropdown(!showDropdown)}
                                        style={{
                                            width: '30px',
                                            height: '30px',
                                            borderRadius: '50%',
                                            backgroundColor: 'var(--accent-primary)',
                                            color: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                            fontSize:"0.9em",
                                        }}
                                        >
                                            {userInitial === null ? <i className="bi bi-person-fill"></i> : userInitial}
                                        </div>

                                        <Dropdown.Menu align="end" show={showDropdown} className="custom-dropdown-menu p-0">
                                            {/* Upgrade link for non-paid subscribers */}
                                            {!isPaidSubscriber(auth) && (
                                                <Dropdown.Item 
                                                    as={Link}
                                                    to="/onboarding/plan" 
                                                    className="pb-2" 
                                                    style={{ color:"var(--accent-accent)", fontSize:"0.9rem"}}
                                                    onClick={() => setShowDropdown(false)}
                                                >
                                                    <i className="bi bi-credit-card me-2"></i>
                                                    Upgrade
                                                </Dropdown.Item>
                                            )}
                                            
                                            <Dropdown.Item 
                                                as={Link}
                                                to="/dashboard" 
                                                className="pb-2" 
                                                style={{ color:"var(--text-secondary)", fontSize:"0.9rem"}}
                                                onClick={() => setShowDropdown(false)}
                                            >
                                                <i className="bi bi-speedometer2 me-2"></i>
                                                Dashboard
                                            </Dropdown.Item>
                                            <Dropdown.Divider className="m-0"/>
                                            <Dropdown.Item 
                                                as={Link}
                                                to="/settings" 
                                                className="pb-2" 
                                                style={{ color:"var(--text-secondary)", fontSize:"0.9rem"}}
                                                onClick={() => setShowDropdown(false)}
                                            >
                                                <i className="bi bi-gear me-2"></i>
                                                Settings
                                            </Dropdown.Item>
                                            <Dropdown.Item 
                                                as={Link}
                                                to="/contact" 
                                                className="pb-2" 
                                                style={{ color:"var(--text-secondary)", fontSize:"0.9rem"}}
                                                onClick={() => setShowDropdown(false)}
                                            >
                                                <i className="bi bi-chat-dots me-2"></i>
                                                Contact
                                            </Dropdown.Item>
                                            <Dropdown.Divider className="m-0"/>
                                            <Dropdown.Item 
                                                as={Link}
                                                to="/logout" 
                                                className="py-2"
                                                style={{color:"var(--text-secondary)", fontSize:"0.9rem"}}
                                                onClick={() => setShowDropdown(false)}
                                            >
                                                <i className="bi bi-box-arrow-right me-2"></i>
                                                Logout
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown> 
                                </div>
                            </div>
                        </Nav>
                    </Container>
                </Navbar>
        </div>
        </>
    )
}

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(HeaderLoggedInDesktop);